import { useContext, useEffect, useState } from 'react';
import NECKLACE from '../Assets/necklace.png';
import BRACLETS from '../Assets/braclets.png';
import EARRING from '../Assets/earring.png';
import axios from 'axios';
import AppContext from '../Context/AppContext';

const Earrings = () => {
  const [selectedImage, setSelectedImage] = useState(null);
 const [images, setImages] = useState([]);
const {apiURL} = useContext(AppContext)

 useEffect(() => {
  const getum = async() => {
    let h = {
      cat:'Earrings'
    }
await axios.post(`${apiURL}/images/getcat`,h)
.then(res =>{
setImages(res.data)
 console.log(res.data)
  })

.catch(err => console.log(err))
  }
  getum()
 },[])


  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <section id="gallery" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-serif font-bold text-center text-gray-800 mb-12">
          Our Earrings Collection
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {images.map((image, index) => (
            <div
              key={index}
              className="group relative bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl animate-fadeIn"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div
                className="cursor-pointer overflow-hidden"
                onClick={() => openModal(image)}
              >
                <img
                  src={image.imagePath}
                  alt={image.alt}
                  className="w-full h-64 object-cover gallery-img transition-transform duration-300 group-hover:scale-110"
                />
              </div>
              <div className="p-6">
                <p className="text-gray-600 text-sm font-medium mb-2 line-clamp-2">
                  {image.description}
                </p>
                <p className="text-gray-400 text-xs font-semibold">
                  SKU: {image.sku}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal for enlarged image */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 animate-fadeIn"
          onClick={closeModal}
        >
          <div
            className="relative max-w-3xl w-full mx-4 bg-white rounded-lg overflow-hidden shadow-2xl animate-zoomIn"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-4 right-4 text-white bg-gray-800 rounded-full p-2 hover:bg-gray-600 transition-colors"
              onClick={closeModal}
            >
              <svg
                className="h-6 w-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <img
              src={selectedImage.src}
              alt={selectedImage.alt}
              className="w-full h-auto max-h-[80vh] object-contain"
            />
            <div className="p-6 bg-white">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                {selectedImage.alt}
              </h3>
              <p className="text-gray-600 text-sm mb-2">
                {selectedImage.description}
              </p>
              <p className="text-gray-400 text-xs font-semibold">
                SKU: {selectedImage.sku}
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Earrings;